module.exports = __webpack_public_path__ + "img/wechat.b0f05433.svg";